"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeIsPartnerTyping = exports.isPartnerTyping = void 0;
var _reselect = require("reselect");
var _chatSelector = require("./chatSelector");
var _partnerSelector = require("./partnerSelector");
var _types = require("../actions/types");
var _getTypingByRoomName = function _getTypingByRoomName(_ref) {
  var typingByRoomName = _ref.typingByRoomName;
  return typingByRoomName;
};
var _getRoomNameFromProps = function _getRoomNameFromProps(_, _ref2) {
  var chat = _ref2.chat;
  return chat.roomname;
};
var isPartnerTyping = exports.isPartnerTyping = (0, _reselect.createSelector)([_chatSelector.getCurrentRoomname, _getTypingByRoomName, _partnerSelector.getCurrentPartnerStatus], function (roomname, typingByRoomName, status) {
  var BLOCKED = _types.PARTNERS_STATUS.BLOCKED,
    DENOUNCED = _types.PARTNERS_STATUS.DENOUNCED,
    BANNED = _types.PARTNERS_STATUS.BANNED;
  if ([BLOCKED, DENOUNCED, BANNED].includes(status)) {
    return false;
  }
  return roomname in typingByRoomName ? typingByRoomName[roomname].isTyping : false;
});
var makeIsPartnerTyping = exports.makeIsPartnerTyping = function makeIsPartnerTyping() {
  return (0, _reselect.createSelector)([_getRoomNameFromProps, _getTypingByRoomName, _partnerSelector.getPartners], function (roomname, typingByRoomName, partners) {
    var BLOCKED = _types.PARTNERS_STATUS.BLOCKED,
      DENOUNCED = _types.PARTNERS_STATUS.DENOUNCED,
      BANNED = _types.PARTNERS_STATUS.BANNED;
    if (!partners[roomname] || [BLOCKED, DENOUNCED, BANNED].includes(partners[roomname].status)) {
      return false;
    }
    return roomname in typingByRoomName ? typingByRoomName[roomname].isTyping : false;
  });
};